import styled from "styled-components";

import { CompainesGrid } from "../../admin/dashboard/companies/companies.styles";
import { Icon } from "../../../components/dashboardComponents/dashboard.styles";

export const ReportsGrid = styled(CompainesGrid)`
  width: 100%;
  grid-template-columns: repeat(auto-fill, 350px);
`;
export const LinkButtonIcon = styled(Icon)`
  width: 14px;
  height: 14px;
`;
export const ReportsContainer = styled.div`
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

export const Th = styled.th`
  background-color: #f2f2f2;
  padding: 10px;
  text-align: left;
  min-width: 200px;
`;

export const Td = styled.td`
  padding: 10px;
  border: 1px solid #ffffff;
  text-transform: capitalize;
  min-width: 100px;

  a {
    color: #64a7c4;
  }

  span {
    font-size: 14px;
  }

  span.my-1 {
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  i {
    margin-left: 0.5rem;
  }
`;

export const Badge = styled.span<{ risk: string }>`
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
  font-weight: bold;
  display: block;
  min-width: 70px;
  cursor: default;
  transition: 0.3s;

  /* Apply different styles based on the risk ratio value */
  ${({ risk }) =>
    risk === "low" &&
    `
    background-color: rgb(100,167,196);
  `}
  ${({ risk }) =>
    risk === "neutral" &&
    `
    background-color: rgb(221, 163, 46);
  `}
  ${({ risk }) =>
    risk === "high" &&
    `
    background-color: #bd1536;
  `}

&:hover {
    ${({ risk }) =>
      risk === "low" &&
      `
    background-color: rgb(85, 141, 165);
  `}
    ${({ risk }) =>
      risk === "neutral" &&
      `
    background-color: rgb(189, 140, 40);
  `}
  ${({ risk }) =>
      risk === "high" &&
      `
    background-color: #ac1433;
  `}
  }
`;

export const ReportsCategory = styled.select`
  outline: none;
  width: 150px;
  font-size: 16px;
`;

export const ReportOption = styled.option`
  &:hover {
    background-color: black;
  }
`;
export const AddReportButton = styled.button`
  padding: 8px 22px;
  color: ${({ theme: { colors } }) => colors.white};
  background-color: ${({ theme: { colors } }) => colors.black};
  align-self: flex-start;
  grid-column: 1 / -1;
`;
export const TypeRadio = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
export const RadioLabel = styled.label`
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
`;
export const InputTitle = styled.div`
  font-size: 1rem;
  font-weight: 500;
`;
export const RadioInput = styled.input`
  cursor: pointer;
`;
